import React, { useRef } from "react";
import { AnimatePresence, motion, useInView } from "framer-motion";
import { ProjectsData } from "../utils/helper";
import { FaEye, FaCode } from "react-icons/fa6";

const Projects = () => {

	const ref = useRef(null);
    const isInView = useInView(ref, {once: true});


    const cardVariants = {
        initial: { y: 50, opacity: 0 },
        animate: { y: 0, opacity: 1},
    }


  return (
    <section
      id="projects"
      className="flex items-center justify-center flex-col gap-12 my-12"
    >
      {/* title */}
      <div className="w-full flex items-center justify-center py-24">
        <motion.div
          initial={{ opacity: 0, width: 0 }}
          animate={{ opacity: 1, width: 200 }}
          exit={{ opacity: 0, width: 0 }}
          transition={{ delay: 0.4 }}
          className="flex items-center justify-around w-52"
        >
          
          <p className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary capitalize text-4xl lg:text-[60px] leading-loose font-serif tracking-widest">
            Projects
          </p>
      
        </motion.div>
      </div>
      {/* <AnimatePresence>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full">
        
          {ProjectsData &&
            ProjectsData.map((project) => (
              <ProjectCard key={project.id} project={project} />
              
            ))}
        
      </div>
      </AnimatePresence> */}
	  <ul ref={ref} className='grid grid-cols-1 lg:grid-cols-3 gap-4 w-full'>
        {ProjectsData.map((project, index) => (
			<AnimatePresence key={index}>
				<motion.li 
				
					variants={cardVariants} 
					initial="initial" 
					animate={isInView ? "animate" : "initial"}
					transition={{ duration: 0.3, delay: index * 0.4}}
				>
					<ProjectCard key={project.id} project={project} />
				</motion.li>
			</AnimatePresence>
        ))}
    </ul>
    </section>
  );
};

const ProjectCard = ({ project }) => {

  return (
   
    <div className='m-4 border border-transparent rounded-xl group  hover:border-primary cursor-pointer hover:shadow-md hover:shadow-primary' >
        <div 
            className='h-72 md:h-72 rounded-t-xl relative ' 
            style={{background: `url(${project.image})`, backgroundSize: "cover"}}>

            {/* when hover on the image display this overlay with icons */}
            <div className='overlay items-center justify-center absolute top-0 left-0 w-full h-full bg-[#181818] bg-opacity-0 hidden group-hover:flex group-hover:bg-opacity-80 group-hover:rounded-t-xl transition-all duration-500'>
                <a target="_blank" rel="noreferrer" href={project.gitUrl} className='h-14 w-14 mr-2 border-2 relative rounded-full border-[#ADB7BE] hover:border-white  group/link'>
                    <FaCode className='h-10 w-10 text-[#ADB7BE] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white' />
                </a>
                <a target="_blank" rel="noreferrer" href={project.previewUrl} className='h-14 w-14 border-2 relative rounded-full border-[#ADB7BE] hover:border-white  group/link'>
                    <FaEye className='h-10 w-10 text-[#ADB7BE] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white' />
                </a>
            </div>
        </div>
        
        <div 
          className='text-texlight hover:text-white rounded-b-xl p-3 bg-bgPrimary border-x border-b border-[rgba(255,255,255,0.3)] py-6 px-4 relative'
          style={{ boxShadow: "inset 0 0 10px rgba(255,255,255,0.3)" }}  
        >
            <h5 className='font-xl font-semibold mb-2'>{project?.title}</h5>
        </div>
    </div>
  );
};

export default Projects;
